import { WhatCanYouDoInversedKeys } from '@teinor/erp/permissions'
import { PermissionModelType } from '@teinor/erp/types/company/userInner/permission'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import { TitleSButtonPermissioned } from '../../../../../../../../baseComponents/Layout/TitleAndRightLayout'
import VirtualTableListing from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing'
import { ColumnTableSchema } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import Checkbox from '../../../../../../../../forms/Checkbox'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { dictionaryFromJsonArr } from '../../../../../../../../utils/globals/dictionary'
import { ComponentTabObject } from '../../../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { changeSuccessMessage } from '../../../../../../../../utils/reducers/reduxDispatch'
import { titleRowRender, parseDataPermissionTable, createTableDataDictionaryPermissions, addOrDeletePermissionTable, addOrDeleteAllPermissionsTable } from './function'
import { PermissionTabRow, PermissionTypeRow, TotalValuePermissionsProps, PermissionCheckboxBase } from './types'

interface PermissionTabProps extends ComponentWithPermissions {
    basicData: ComponentTabObject
 }
interface PermissionExtended extends PermissionModelType {
    text: string
}
const margins: {[key: number]: string} = {
    0: '',
    1: 'ml-20',
    2: 'ml-40',
    3: 'ml-60'
}
const PermissionTab: React.FC<PermissionTabProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()
    const { tableData, savePermissions, handleChangePermission, handleChangeAllPermissions, GroupId } = usePermissionTabLogic()
    const columns: ColumnTableSchema<PermissionExtended> = [
        {
            id: 'idPermission',
            dataKey: 'idPermission',
            label: '',
            className: 'titlePerm', 
            minWidth: 250,
            customRender: (parameterValue, allRowData) =><IdPermission dataKey={parameterValue} title={allRowData.title} />
        },
        {
            id: 'permission1',
            dataKey: 'permission',
            label: '',
            minWidth: 100,
            customRender: (_parameterValue, allRowData) => <RenderPermissionsRow sectionKey={allRowData.sectionKey} GroupId={parseInt(allRowData.GroupId)} type={allRowData.type} idPermission={allRowData.idPermission} columnPermission={1} permission={allRowData.value} handleChangePermission={(permission) => handleChangePermission(permission, allRowData.rowIndex)} handleChangeAllPermissions={(permission) => handleChangeAllPermissions(permission, allRowData.rowIndex)} maxRows={allRowData.maxRows} totalValues={allRowData.totalValues} />
        },
        {
            id: 'permission2',
            dataKey: 'permission',
            label: '',
            minWidth: 100,
            customRender: (_parameterValue, allRowData) => <RenderPermissionsRow sectionKey={allRowData.sectionKey} GroupId={parseInt(allRowData.GroupId)} type={allRowData.type} idPermission={allRowData.idPermission} columnPermission={2} permission={allRowData.value} handleChangePermission={(permission) => handleChangePermission(permission, allRowData.rowIndex)} handleChangeAllPermissions={(permission) => handleChangeAllPermissions(permission, allRowData.rowIndex)} maxRows={allRowData.maxRows} totalValues={allRowData.totalValues} />
        },
        {
            id: 'permission3',
            dataKey: 'permission',
            label: '',
            minWidth: 100,
            customRender: (_parameterValue, allRowData) => <RenderPermissionsRow sectionKey={allRowData.sectionKey} GroupId={parseInt(allRowData.GroupId)} type={allRowData.type} idPermission={allRowData.idPermission} columnPermission={3} permission={allRowData.value} handleChangePermission={(permission) => handleChangePermission(permission, allRowData.rowIndex)} handleChangeAllPermissions={(permission) => handleChangeAllPermissions(permission, allRowData.rowIndex)} maxRows={allRowData.maxRows} totalValues={allRowData.totalValues} />
        },
        {
            id: 'permission4',
            dataKey: 'permission',
            label: '',
            minWidth: 100,
            customRender: (_parameterValue, allRowData) => <RenderPermissionsRow sectionKey={allRowData.sectionKey} GroupId={parseInt(allRowData.GroupId)} type={allRowData.type} idPermission={allRowData.idPermission} columnPermission={4} permission={allRowData.value} handleChangePermission={(permission) => handleChangePermission(permission, allRowData.rowIndex)} handleChangeAllPermissions={(permission) => handleChangeAllPermissions(permission, allRowData.rowIndex)} maxRows={allRowData.maxRows} totalValues={allRowData.totalValues} />
        },
    ]
    return (
        <TitleSButtonPermissioned title={basicData?.[GroupId]?.text as string} buttonText={t('save', 'Guardar')} onClick={savePermissions} userPermissions={userPermissions} permission='update' >
            <div className='flex-auto'>
                <VirtualTableListing name='permissionTab' tableData={tableData} columns={columns} headerHeight={0} rowRenderer={titleRowRender}/>
            </div>
        </TitleSButtonPermissioned>
    )
}

export type DictPermissions = {[key: string]: WhatCanYouDoInversedKeys | undefined}
const usePermissionTabLogic = () => {
    const [tableData, setTableData] = useState<PermissionTabRow[] | null>(null)
    const params = useParams<{ id: string }>()
    const GroupId = params?.id || '0'
    const { t } = useTwinTranslation()

    const permissionsTranslateStr = useMemo(() => {
        return JSON.stringify({
            generic: {
                title: t('content', 'Contenido'),
                permissions: {
                    'workingCenter': t('workingCenters', 'Centros de trabajo'),
                    'workingCenter.main': t('workingCenterMain', 'Centros de Trabajo Principal'),
                    'workingCenter.station': t('workingCenterStation', 'Centros de Trabajo Puestos'),
                    'workingCenter.workingCenterType': t('workingCenterWorkingCenterType', ' Tipos  Centros de Trabajo'),
                    'workingCenter.employee': t('workingCenterEmployee', 'Empleados Centros de trabajo'),
                    'sue': t('sues', 'Denuncias'),
                    'contactPerson': t('contactPersons', 'Personas'),
                    'customer': t('customers', 'Clientes'),
                    'customer.customerGroup': t('customerTypes', 'Tipo de clientes'),
                    'customer.customerProjectType': t('projectsTypes', 'Tipo de proyectos'),
                    'customer.origin': t('customerOrigin', 'Origen de cliente'),
                    'customer.campaigns': t('campaignsCustomer', 'Campañas de clientes'),
                    'customer.campaigns.main': t('campaignsCustomerMain', 'Campañas de clientes - Principal'),
                    'customer.campaigns.inner': t('campaignsCustomerInner', 'Campañas de clientes - Ficha individual'),
                    'customer.projects': t('customerProjects', 'Proyectos de clientes'),
                    'customer.projects.main': t('customerProjectsMain', 'Proyectos de clientes - Principal'),
                    'customer.projects.checklists': t('customerProjectsChecklistsPermissions', 'Proyectos de clientes - Listas'),
                    'customer.projects.checklistmark': t('customerProjectsChecklistMarkPermissions', 'Proyectos de clientes - Marcar listas'),
                    'customer.projects.checklistLogs': t('customerProjectsChecklistsLogsPermissions', 'Proyectos de clientes - Registros Listas'),
                    'customer.profile': t('customersProfilePermissions', 'Ficha de clientes'),
                    'customer.profile.main': t('customersProfilePermissionsMain', 'Ficha de clientes - Principal'),
                    'customer.profile.address': t('customersProfilePermissionsAddress', 'Ficha de clientes - Direcciones'),
                    'customer.profile.bank': t('customersProfilePermissionsBanks', 'Ficha de clientes - Bancos'),
                    'customer.profile.contactPerson': t('customersProfilePermissionsContactPersons', 'Ficha de clientes - Personas de contacto'),
                    'customer.profile.shops': t('customersProfilePermissionsWorkingCenters', 'Ficha de clientes - Centros de trabajo'),
                    'customer.profile.projects': t('customersProfilePermissionsProjects', 'Ficha de clientes - Proyectos'),
                    'customer.profile.bagOfHours': t('customersProfilePermissionsBagOfHours', 'Ficha de clientes - Bolsas de horas'),
                    'customer.profile.campaign': t('customersProfilePermissionsCampaigns', 'Ficha de clientes - Campañas'),
                    'customer.profile.notes': t('customersProfilePermissionsNotes', 'Ficha de clientes - Notas'),
                    'customer.profile.tasks': t('customersProfilePermissionsTasks', 'Ficha de clientes - Tareas'),
                    'customer.profile.quotes': t('customersProfilePermissionsQuotes', 'Ficha de clientes - Presupuestos'),
                    'customer.profile.files': t('customersProfilePermissionsFiles', 'Ficha de clientes - Ficheros'),
                    'customer.profile.gdpr': t('customersProfilePermissionsGDPR', 'Ficha de clientes - RGPD'),
                    'customer.profile.materialStock': t('customersProfileMaterialStock', 'Ficha de clientes - Stock materiales'),
                    'customer.materialStock': t('customersStockMaterialPermissions', 'Depósitos de materiales del cliente'),
                    'employee': t('employees', 'Empleados'),
                    'employee.main': t('employeesMainTab', 'Empleados Pestaña Principal'),
                    'employee.notes': t('employeesNotesTab', 'Empleados Pestaña Notas'),
                    'employee.files': t('employeesFilesTab', 'Empleados Pestaña Ficheros'),
                    'employee.holidays': t('employeesHolidayTab', 'Empleados Pestaña Vacaciones '),
                    'employee.absences': t('employeesAbsenceTab', 'Empleados Pestaña Ausencias'),
                    'employee.payslip': t('employeesPayslipTab', 'Empleados Pestaña Nóminas'),
                    'employee.expenses': t('employeesExpensesTab', 'Empleados Pestaña Gastos'),
                    'employee.agreementHours': t('employeesAgreementHoursTab', 'Empleados Pestaña Horas Convenio'),
                    'group': t('groups', 'Grupos'),
                    'group.permissions': t('groupPermissions', 'Permisos de Grupo'),
                    'group.users': t('groupUsers', 'Usuarios de grupo'),
                    'WCal': t('timeControl', 'Control horario'),
                    'WCal.main': t('workingCalendarMain', 'Calendario laboral Principal'),
                    'WCal.schedule': t('workingCalendarSchedule', 'Horario'),
                    'WCal.free': t('workingCalendarFree', 'Calendario de días festivos'),
                    'WCal.holiday.bags': t('holidayBags', 'Bolsas de vacaciones'),
                    'WCal.holiday.usedDays': t('holidayListing', 'Listado de vacaciones'),
                    'WCal.overtime': t('overtimeControl', 'Control de horas extra'),
                    'WCal.checkEmployeeMonth': t('controlWorkingMonth', 'Control calendario del mes'),
                    'WCal.special': t('workingCalendarSpecialDays', 'Calendarios de días especiales'),
                    'WCal.absences': t('employeeAbsences', 'Ausencias de empleados'),
                    'WCal.absences.control': t('employeeAbsencesControl', 'Control ausencias de empleados'),
                    'WCal.absences.type': t('employeeAbsenceTypes', 'Tipos de ausencias de empleado'),
                    'WCal.turn': t('turn', 'Turnos'),
                    'warehouse': t('warehouse', ' Almacén'),
                    'warehouse.main': t('warehouseMain', ' Almacén principal'),
                    'warehouse.stock': t('warehouseStock', ' Inventario de almacén'),
                    'warehouse.stock.costs': t('warehouseStockCosts', ' Almacén coste de inventario'),
                    'supplier': t('suppliers', 'Proveedores'),
                    'supplier.main': t('suppliersMainTab', 'Proveedores Pestaña Principal'),
                    'supplier.tradeAgreements': t('suppliersTradeAgreementsTab', 'Proveedores Pestaña Acuerdos comerciales'),
                    'supplier.contactPersons': t('suppliersContactPersonsTab', 'Proveedores Pestaña Personas de contacto'),
                    'supplier.bank': t('suppliersBanksTab', ' Proveedores Pestaña Bancos'),
                    'supplier.service': t('suppliersServicesTab', ' Proveedores Pestaña Servicios'),
                    'supplier.files': t('suppliersFilesTab', 'Proveedores Pestaña Ficheros'),
                    'creditor': t('creditors', 'Acreedores'),
                    'creditor.main': t('creditorsMainTab', 'Acreedores Pestaña Principal'),
                    'creditor.tradeAgreements': t('creditorsTradeAgreementsTab', 'Acreedores Pestaña Acuerdos comerciales'),
                    'creditor.contactPersons': t('creditorsContactPersonsTab', 'Acreedores Pestaña Personas de contacto'),
                    'creditor.bank': t('creditorsBanksTab', ' Acreedores Pestaña Bancos'),
                    'creditor.service': t('creditorsServicesTab', ' Acreedores Pestaña Servicios'),
                    'creditor.files': t('creditorsFilesTab', 'Acreedores Pestaña Ficheros'),
                    'product': t('products', 'Productos'),                   
                    'product.profile': t('productsProfile', 'Perfil Productos'),                   
                    'product.profile.main': t('productMainTab', 'Producto Pestaña Principal'),
                    'product.profile.features': t('productFeatures', 'Características de Producto'),
                    'product.profile.supplier': t('productSuppliers', 'Proveedores de Producto'),
                    'product.profile.specificPrice': t('productSpecificPrices', 'Precios de Producto'),
                    'product.profile.stock': t('productStocks', 'Inventarios de Producto'),
                    'product.profile.otherInformation': t('productOtherInformation', 'Otra información de Producto'),
                    'product.profile.variant': t('productVariants', 'Variantes de Producto'),
                    'product.profile.sells': t('productSells', 'Ventas del Producto'),
                    'product.profile.productComposed': t('productProductComposeds', 'Productos Compuestos de Producto'),
                    'product.profile.productAddon': t('productAddons', 'Complementos del producto'),
                    'product.profile.serialized': t('productWithSerialNumber', 'Producto con número de serie'),
                    'product.profile.lot': t('productLot', 'Lote de productos'),
                    'product.profile.discount': t('productDiscount', 'Descuentos de Producto'),
                    'product.profile.web': t('productWebTab', 'Producto Pestaña Web'),
                    'product.service.main': t('serviceMainTab', 'Servicio Pestaña Principal'),
                    'product.service.features': t('serviceFeatures', 'Características de servicios'),
                    'product.service.discount': t('serviceDiscount', 'Descuentos de servicios'),
                    'product.service.supplier': t('serviceSuppliers', 'Proveedores de servicios'),
                    'product.service.specificPrice': t('serviceSpecificPrices', 'Precios de servicios'),
                    'product.service.otherInformation': t('serviceOtherInformation', 'Otra información del servicio'),
                    'product.service.variant': t('serviceVariants', 'Variantes de servicios'),
                    'product.service.productComposed': t('serviceProductComposeds', 'Productos compuestos de servicios'),
                    'product.service.productAddon': t('serviceAddons', 'Complementos del servicio'),
                    'product.service.web': t('serviceWebTab', 'Servicio Pestaña Web'),
                    'product.service': t('services', 'Servicios'),
                    'product.category': t('categories', 'Categorías'),
                    'product.features': t('features', 'Características'),
                    'product.variant': t('variants', 'Variantes'),
                    'product.specificPriceRules': t('rateGroups', 'Grupos de tarifas'),
                    'product.priceZone': t('priceZones', 'Zonas de precios'),
                    'product.brand': t('brands', 'Marcas'),
                    'product.packaging': t('packagings', 'Packagings'),
                    'product.packaging.main': t('packagingMain', 'Packaging Pestaña Principal'),
                    'product.packaging.supplier': t('packagingSupplier', 'Packaging Pestaña Proveedores'),
                    'product.packaging.specificPrice': t('packagingSpecificPrice', 'Packaging Pestaña Precios'),
                    'product.packaging.stock': t('packagingStock', 'Packaging Pestaña Inventario'),
                    'product.packaging.otherInformation': t('packagingOtherInformationTab', 'Packaging Pestaña Otra Información'),
                    'product.packaging.productComposed': t('packagingProductComposed', 'Packaging Pestaña Producto Compuesto'),
                    'product.addon': t('addons', 'Complementos'),
                    'product.addon.main': t('addonMainTab', 'Complementos Pestaña Principal'),
                    'product.addon.specificPrice': t('addonPriceTab', 'Complementos Pestaña Precios'),
                    'product.addon.stock': t('addonStockTab', 'Complementos Pestaña Inventario'),
                    'product.addon.supplier': t('addonSuppliersTab', 'Complementos Pestaña Proveedores'),
                    'product.addon.otherInformation': t('addonOtherInformationTab', 'Complementos Pestaña Otra Información'),
                    'product.addonCategory': t('addonCategory', 'Categoría de complementos'),
                    'product.material': t('materials', 'Materiales'),
                    'product.material.main': t('materialMainTab', 'Material Pestaña Principal'),
                    'product.material.supplier': t('materialSuppliers', 'Material Pestaña Proveedores'),
                    'product.material.specificPrice': t('materialPriceTab', 'Material Pestaña Precios'),
                    'product.material.stock': t('materialStock', 'Material Pestaña Inventario'),
                    'product.material.variant': t('materialVariants', 'Material PestañaVariantes'),
                    'product.material.features': t('materialFeatures', 'Características de materiales'),
                    'product.materialCategory': t('materialCategory', 'Categoría de materiales'),
                    'product.type': t('productType', 'Tipos de producto'),
                    'expenses': t('employeesExpenses', 'Gastos empleados'),
                    'expenses.main': t('employeesExpensesListing', 'Listado gastos empleados'),
                    'expenses.rowType': t('employeesExpensesTypes', 'Tipos de gastos empleados'),
                    'quote': t('quotes', 'Presupuestos'),
                    'quote.order': t('quoteMain', 'Presupuestos pestaña principal'),
                    'quote.stats': t('quoteStats', 'Presupuesto estadísticas'),
                    'quote.tags': t('quoteTags', 'Etiquetas de presupuesto'),
                    'sell': t('sells', 'Ventas'),
                    'sell.order': t('sellOrdersSell', 'Pedidos de venta'),
                    'sell.deliveryNote': t('sellDeliveryNotes', 'Albaranes de venta'),
                    'sell.refundDeliveryNote': t('sellDeliveryNoteRefund', 'Devolución de albaranes de venta'),
                    'sell.invoice': t('sellInvoices', 'Facturas de venta'),
                    'sell.refundInvoice': t('sellInvoicesRefund', 'Devolución de facturas de venta'),
                    'sell.reparation': t('reparations', 'Reparaciones'),
                    'sell.workSheetProductStatus': t('workSheetsProductStatus', 'Hojas de trabajo'),
                    'sell.stats': t('sellStats', 'Estadísticas de ventas'),
                    'sell.tags': t('sellTags', 'Etiquetas de ventas'),
                    'sell.multi': t('generateMultiSells', 'Generar múltiples en ventas'),
                    'sell.multi.order': t('generateMultOrders', 'Generar pedidos múltiples'),
                    'sell.multi.deliveryNote': t('generateMultiDeliveryNotes', 'Generar albaranes múltiples'),
                    'sell.multi.invoice': t('generateMultiInvoices', 'Generar facturas múltiples'),
                    'sell.tickets': t('sellTickets', 'Tickets de venta'),
                    'sell.refundTickets': t('sellTicketsRefund', 'Devolución de tickets'),
                    'buy': t('buys', 'Compras'),
                    'buy.order': t('buyOrder', 'Pedidos de compra'),
                    'buy.deliveryNote': t('buyDeliveryNote', 'Albaranes de compra'),
                    'buy.invoice': t('buyInvoice', 'Facturas de compra'),
                    'buy.tags': t('buyTags', 'Etiquetas de compra'),
                    'config': t('config', 'Configuración'),
                    'config.parameter': t('parameters', 'Parametros'),
                    'config.serviceType': t('serviceTypes', 'Tipos de servicio'),
                    'config.vat': t('vats', 'Impuestos'),
                    'config.cost': t('costsSells', 'Costes de venta'),
                    'config.currency': t('currency', 'Moneda'),
                    'config.lang': t('language', 'Idioma'),
                    'config.sellVariable': t('sellVariables', 'Variables de venta'),
                    'config.workSheetGroupStatus': t('workSheetGroups', 'Grupos de hojas de trabajo'),
                    'config.shipping': t('shippingCompanies', 'Transportistas'),
                    'config.shipping.shippingCompany': t('shippingCompaniesM', 'Transportistas (Empresa)'),
                    'config.shipping.shippingZone': t('shippingZones', 'Zonas de envíos'),
                    'config.customerProject': t('customerProjects', 'Proyectos del cliente'),
                    'config.customerProject.templateChecklist': t('templateLists', 'Plantilla de lista'),
                    'task': t('tasks', 'Tareas'),
                    'task.main': t('taskMain', 'Tarea principal'),
                    'task.bagOfHours': t('bagOfHours', 'Bolsas de horas'),
                    'task.CField': t('customFields', 'Campos personalizados'),
                    'task.taskType': t('taskType', 'Tipo de tarea'),
                    'task.repository': t('taskRepository', 'Repositorio'),
                    'manufacturing': t('manufacturing', 'Fabricación'),
                    'manufacturing.main': t('manufacturingMain', 'Fabricación principal'),
                }
            },
            special: {
                title: t('otherPermissions', 'Otros permisos'),
                permissions: {
                    'employeeView': t('seeAllEmployee', 'Ver todos los empleados'),
                    'employeeView.workingCenterGroup': t('seeAllEmployeesMyGroupsAndWC', 'Ver todos los empleados de mis grupos de mis centros de trabajo'),
                    'employeeView.group': t('seeAllEmployeesMyGroups', 'Ver todos los empleados de mis grupos'),
                    'employeeView.workingCenter': t('seeAllEmployeesMyWorkingCenters', 'Ver todos los empleados de mi centro de trabajo'),
                    'taskView': t('tasks', 'Tareas'),
                    'taskView.getAllTasks': t('allTasks', 'Todas las tareas'),
                    'taskView.getTasksFromGroupUsers': t('tasksOtherGroupsUsers', 'Tareas otros empleados de tu grupo'), 
                    'taskView.getTasksOtherGroup': t('tasksOtherGroup', 'Tareas de otros grupos'),
                    'taskView.getTasksOtherWorkingCenter': t('TasksOtherWorkingCenter', 'Tareas de otros centros de trabajo'),
                    'groupView': t('seeAllGroups', 'Ver todos los grupos'),
                    'skipRestrictTimeControlAccess': t('skipRestrictTimeControlAccess', 'Evitar restricción de tiempo de acceso'),
                    'generateCodebar': t('generateCodebars', 'Generar códigos de barras'),
                    'generateQRCodes': t('generateQRCodes', 'Generar códigos QR'),
                    'skipQrTimeControl': t('skipQrTimeControl', 'Evitar fichar por Qr'),
                    'skipGeolocationTimeControl': t('skipGeolocationTimeControl', 'Evitar fichar por geolocalización'),
                    'quoteOther': t('quotes', 'Presupuestos'),
                    'quoteOther.seeOtherEmployeeQuotes': t('ableToSeeQuotesFromOthersEmployees', 'Poder ver los presupuestos de otros empleados'),
                    'quoteOther.seeOtherWorkingCenterQuotes': t('ableToSeeQuotesFromOthersWorkingCenters', 'Poder ver los presupuestos de otros Centros de trabajo'),
                    'quoteOther.seeAllQuotes': t('ableToSeeAllQuotes', 'Poder ver todos los presupuestos'),
                    'quoteOther.seeAllQuotesFromCustomer': t('ableToSeeAllQuotesFromCustomer', 'Poder ver todos los presupuestos desde el cliente'),
                    'quoteOther.seeOtherPrices': t('ableToSeeOtherQuotesPrices', 'Poder ver precios de otros presupuestos'),
                    'quoteOther.modifyOtherQuotes': t('ableToModifyOtherQuotes', 'Poder modificar otros presupuestos'),
                    'quoteOther.updateQuoteSpecificPrice': t('ableToChangeSpecificPriceOfRow', 'Poder modificar la tarifa de una línea'),
                    'quoteOther.updateQuoteTotalPrice': t('ableToAdjustQuoteFinalPrice', 'Poder ajustar precio final presupuesto'),
                    'sellOther': t('Sells', 'Ventas'),
                    'sellOther.seeOtherEmployeeSells': t('ableToSeeSellsFromOthersEmployees', 'Poder ver las ventas de otros empleados'),
                    'sellOther.seeOtherWorkingCenterSells': t('ableToSeeSellsFromOthersWorkingCenters', 'Poder ver las ventas de otros Centros de trabajo'),
                    'sellOther.seeAllCashSells': t('ableToSeeAllCashSells', 'Poder ver todas las ventas de caja'),
                    'sellOther.seeAllSells': t('ableToSeeAllSells', 'Poder ver todas las ventas'),
                    'sellOther.seeAllVouchers': t('ableToSeeAllVouchers', 'Poder ver todos los vales'),
                    'sellOther.seeOtherPrices': t('ableToSeeOtherSellsPrices', 'Poder ver precios de otras ventas'),
                    'sellOther.modifyOtherSells': t('ableToModifyOtherSells', 'Poder modificar otras ventas'),
                    'sellOther.updateSellSpecificPrice': t('ableToChangeSpecificPriceOfRow', 'Poder modificar la tarifa de una línea'),
                    'sellOther.updateSellTotalPrice': t('ableToAdjustSellFinalPrice', 'Poder ajustar precio final de la venta'),
                    'sellOther.updateSellQuantity': t('ableToUpdateSellQuantityFromWorkSheet', 'Poder modificar la cantidad del producto desde la hoja de trabajo'),
                    'sellOther.sellWithoutStock': t('ableToSellWithoutStock', 'Poder vender sin stock'),
                    'sellOther.seeOtherEmployeeWorkSheets': t('ableToSeeWorkSheetsFromOthersEmployees', 'Poder ver las hojas de trabajo de otros empleados'),
                    'sellOther.seeOtherWorkingCenterWorkSheets': t('ableToSeeWorkSheetsFromOthersWorkingCenters', 'Poder ver las hojas de trabajo de otros Centros de trabajo'),
                    'sellOther.seeAllWorkSheets': t('ableToSeeAllWorkSheets', 'Poder ver todas las hojas de trabajo'),
                    'sellOther.modifyOtherWorkSheets': t('ableToModifyOtherWorkSheets', 'Poder modificar otras hojas de trabajo'),
                    'sellOther.downloadCsv': t('ableToADownloadSellCSV', 'Poder descargar CSV de ventas'),
                    'sellOther.createDiscounts': t('ableToCreateDiscounts', 'Poder hacer descuentos'),
                    'sellOther.canRegularizeSellTicket': t('canRegularizeSellTicket', 'Poder regularizar tickets de venta'),
                    'buyOther' : t('buys', 'Compras'),
                    'buyOther.seeOtherWorkingCenterBuys': t('ableToSeeBuysFromOthersWorkingCenters', 'Poder ver las compras de otros Centros de trabajo'),
                    'buyOther.seeAllBuys': t('ableToSeeAllBuys', 'Poder ver todas las compras'),
                    'buyOther.modifyOtherBuys': t('ableToModifyOtherBuys', 'Poder modificar otras compras'),
                    'buyOther.seeOtherPrices': t('ableToSeeOtherBuyPrices', 'Poder ver precios de otras compras'),
                    'buyOther.downloadCsv': t('ableToADownloadBuyCSV', 'Poder descargar CSV de compras'),
                    'bagOfHoursDownloadPdf': t('bagOfHoursDownloadPdf', 'Descargar PDF de bolsa de horas'),
                    'customerProjectOther': t('customerProjects','Proyectos de clientes'),
                    'customerProjectOther.seeCustomerProjectAmounts': t('seeCustomerProjectAmounts', 'Poder ver las cantidades de los proyectos'),
                    'customerProjectOther.seeOtherCustomerProjectAmounts': t('seeOtherCustomerProjectAmounts', 'Poder ver las cantidades de otros proyectos'),
                    'productOther': t('products', 'Productos'),
                    'productOther.importProducts': t('ableToImporProducts', 'Poder importar productos'),
                    'manufacturingOther': t('manufacturing', 'Fabricación'),
                    'manufacturingOther.seeOtherWorkingCenterManufacturings': t('ableToSeeManufacturingsFromOthersWorkingCenters', 'Poder ver las fabricaciones de otros Centros de trabajo'),
                    'manufacturingOther.seeAllManufacturings': t('ableToSeeAllManufacturings', 'Poder ver todas las fabricaciones'),
                    'manufacturingOther.modifyOtherManufacturings': t('ableToModifyOtherManufacturings', 'Poder modificar otras fabricaciones'),
                    'manufacturingOther.seeOtherPrices': t('ableToSeeOtherManufacturingPrices', 'Poder ver precios de otras fabricaciones'),
                    'manufacturingOther.downloadCsv': t('ableToADownloadManufacturingCSV', 'Poder descargar CSV de fabricaciones'),
                }
            },
        })
    }, [t])
    
    const getTableData = useCallback(async () => {
        const result: PermissionModelType[] = await twinFetchPostJSON('/api/app/permission/getAllPermissions', { GroupId })
        const permissionsTranslate = JSON.parse(permissionsTranslateStr)
        const resultDict = dictionaryFromJsonArr(result, 'idPermission', 'permission')
        const dataParsed = parseDataPermissionTable(permissionsTranslate, resultDict, GroupId)
        setTableData(dataParsed)
    }, [setTableData, permissionsTranslateStr, GroupId])

    const savePermissions = useCallback(async () => {
        const successMessage = t('updatedAllPermissions', 'Permisos actualizados')
        const dictTableData = createTableDataDictionaryPermissions(tableData)
        const petition = await twinFetchPostJSON('/api/app/permission/updateAllPermissions', {
            permissions: dictTableData,
            GroupId
        })
        if (petition) {
            changeSuccessMessage(successMessage)
            getTableData()
        }
    }, [getTableData, GroupId, tableData, t])

    const handleChangePermission = useCallback((newPermission: WhatCanYouDoInversedKeys, index: number) => {
        setTableData((old) => {
            if (!old) {
                return null
            }
            if (parseInt(String(GroupId)) !== 1) {
                const data = addOrDeletePermissionTable(old, { newPermission, index })    
                return data
            }
            return old
        })
    }, [setTableData, GroupId])

    const handleChangeAllPermissions = useCallback((newPermission: WhatCanYouDoInversedKeys, index: number) => {
        setTableData((old) => {
            const data = addOrDeleteAllPermissionsTable(old, { newPermission, index })
            return data
        })
    }, [setTableData])

    useEffect(() => {
        getTableData()
    }, [getTableData])

    return { tableData, getTableData, savePermissions, handleChangePermission, handleChangeAllPermissions, GroupId }
}

interface IdPermissionProps  {
    dataKey: string
    title: string
}

const IdPermission: React.FC<IdPermissionProps> = ({title, dataKey}) => {
    return (<div className={margins[dataKey?.match(/[.]/g)?.length || 0]}>{title}</div>)
}

interface RenderPermissionsRowProps {
    columnPermission: WhatCanYouDoInversedKeys
    permission?: number
    sectionKey: string
    idPermission: string
    type: PermissionTypeRow
    GroupId: number
    handleChangePermission: (permission: WhatCanYouDoInversedKeys) => void
    handleChangeAllPermissions: (permission: WhatCanYouDoInversedKeys) => void
    maxRows: number
    totalValues: TotalValuePermissionsProps
}

const RenderPermissionsRow: React.FC<RenderPermissionsRowProps> = ({ columnPermission, permission, handleChangePermission, type, handleChangeAllPermissions, GroupId, maxRows, totalValues, sectionKey }) => {
    if (type === 'section' || (sectionKey === 'special' &&  columnPermission !== 1)) {
        return null
    }
    if (type === 'config') {
        let checkMaxColumns = totalValues?.[columnPermission] === maxRows ? true : false
        if (parseInt(String(GroupId)) === 1) {
            checkMaxColumns = true
        } 
        return <PermissionAllCheckbox GroupId={GroupId} columnPermission={sectionKey === 'special'? 4:  columnPermission} handleChangeAllPermissions={handleChangeAllPermissions} checked={checkMaxColumns} {...{ sectionKey }} />
    }   
    
    return (<PermissionCheckbox checked={permission? columnPermission <= permission : false} columnPermission={columnPermission} permission={permission} handleChangePermission={handleChangePermission}  />)
}

interface PermissionCheckboxProps extends PermissionCheckboxBase {
    handleChangePermission: (permission: WhatCanYouDoInversedKeys) => void
    permission?: number
}
const PermissionCheckbox: React.FC<PermissionCheckboxProps> = ({ checked, columnPermission, handleChangePermission }) => {   
    return (<Checkbox label={''} checked={checked} onChange={() => handleChangePermission(columnPermission)} />)
}

interface PermissionAllCheckboxProps extends PermissionCheckboxBase {
    sectionKey: string
    GroupId: number
    handleChangeAllPermissions: (permission: WhatCanYouDoInversedKeys) => void
}

const PermissionAllCheckbox: React.FC<PermissionAllCheckboxProps> = ({ GroupId, handleChangeAllPermissions, columnPermission, checked, sectionKey }) => {    
    const {t} = useTwinTranslation()
    const titlesConfig: {[key: number]: string} = {
        1: t('read', 'Leer'), 
        2: t('create', 'Crear'),
        3: t('update', 'Actualizar'),
        4: sectionKey ==='special'? t('havePermissions', 'Tiene permisos'): t('delete', 'Eliminar')
    }
    if(sectionKey === 'special'){
        titlesConfig[1] = t('see', 'Ver')
    }
    return <Checkbox label={titlesConfig[columnPermission]} onChange={() => { if (GroupId !== 1) { handleChangeAllPermissions(columnPermission) } }} checked={checked} />
}

export default PermissionTab